import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles<Theme>(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 850,
    padding: '0 50px 0 50px',
    backgroundColor: '#fff',
    borderRadius: 0,
    position: 'relative',
    color: '#A0A3B5',
    fontWeight: 300,
    '& .MuiInputBase-root': {
      height: 25,
      fontWeight: 300,
      fontSize: '1rem',
      lineHeight: '1rem',
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.common.grey,
          borderWidth: 1
        }
      },
      '&.Mui-disabled:hover': {
        background: 'unset'
      },
      '& > .MuiInputBase-input': {
        fontSize: '1rem',
        padding: '5px 15px',
        [theme.breakpoints.down('xs')]: {
          padding: '5px 0 5px 7px'
        }
      },
      [theme.breakpoints.down('sm')]: {
        paddingRight: 0
      }
    },
    '& .MuiTypography-root': {
      fontSize: '1rem',
      padding: '0 10px',
      fontWeight: 300,
      '&:hover': {
        background: 'unset'
      },
      '&:first-child': {
        paddingLeft: 0
      }
    },
    '& first .MuiTypography-root': {
      fontSize: '1rem',
      padding: '0 10px',
      fontWeight: 300,
      '&:hover': {
        background: 'unset'
      }
    },
    '& .Mui-disabled .MuiSelect-icon': {
      display: 'none'
    },
    [theme.breakpoints.down('md')]: {
      borderRadius: 12,
      width: 'calc(100vw - 25px)'
    },
    [theme.breakpoints.down('sm')]: {
      padding: 14,
      marginTop: 30
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    [theme.breakpoints.down('xs')]: {
      '& :nth-child(2)': {
        marginLeft: 8
      }
    }
  },
  hometown: {
    color: theme.palette.common.lightOrange
  },
  schoolContainer: {
    '& .MuiInputBase-root': {
      color: theme.palette.common.darkGrey
    }
  },
  schoolRoot: {
    position: 'relative',
    marginTop: 24
  },
  schoolLabel: {
    color: 'black'
  },
  userNameContainer: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  },
  userName: {
    fontSize: '15pt !important',
    marginBottom: 30,
    marginTop: 15,
    width: '100%',
    justifyContent: 'center',
    color: '#6c6471'
  }
}))
